import { EFinancingProgram } from '@if/core/types'
import { groupBy } from 'lodash-es'
import { useMemo } from 'react'
import { RateAgreement } from '../types/Merchant'

export const useRateAgreementsByFinancingProgram = (
  rateAgreements?: RateAgreement[] | null,
): Record<EFinancingProgram, RateAgreement[]> => {
  return useMemo(() => {
    const groups = groupBy<RateAgreement>(rateAgreements ?? [], (agreement) => {
      return agreement.financingProgramId
    }) as Record<EFinancingProgram, RateAgreement[]>

    Object.entries(groups).forEach(([, agreements]) => {
      agreements.sort((a, b) => {
        return b.minErs - a.minErs
      })
    })
    return groups
  }, [rateAgreements])
}
